module.exports = __webpack_public_path__ + "img/comp-loto-instruments.c55d807d.svg";